// @flow
import React from 'react'
import formatters from 'lib/formatters'
import styles from './styles.css'

type Props = {
  vehicle: ?Object,
}

const getVehicleRows = ({ purchase_date, purchase_amount, make, model, year, trim, vin, mileage }: Object) => [
  ['Purchase Date', purchase_date ? formatters.date(purchase_date) : null],
  ['Purchase Amount', purchase_amount ? formatters.money(purchase_amount) : null],
  ['Make', make],
  ['Model', model],
  ['Year', year],
  ['Trim', trim],
  ['VIN', vin],
  ['Mileage', mileage === 0 || mileage ? Number(mileage).toLocaleString('en-US') : null],
]

const VehicleInfoSection = ({ vehicle }: Props) => {
  if (!vehicle) return null

  const { primary_garage_street_1, primary_garage_street_2, primary_garage_city, primary_garage_state, primary_garage_zip } = vehicle

  const street = [primary_garage_street_1, primary_garage_street_2].filter(Boolean).join(' ')
  const cityState = [primary_garage_city, primary_garage_state].filter(Boolean).join(', ')
  const cityLine = [cityState, primary_garage_zip].filter(Boolean).join(' ')

  const rows = getVehicleRows(vehicle)

  return (
    <div>
      <div className={styles.card}>
        <div className={styles.title}>
          <h5>Primary Garage Location</h5>
        </div>
        <div className={styles.address}>
          {street || cityLine ? (
            <>
              <div>{street}</div>
              <div>{cityLine}</div>
            </>
          ) : (
            '-'
          )}
        </div>
      </div>
      <div className={styles.card}>
        <div className={styles.title}>
          <h5>Vehicle</h5>
        </div>
        {rows.map(([label, value]) => (
          <div className={styles.singleLine} key={label}>
            <div className={styles.label}>{label}</div>
            <div className={styles.value}>{value === 0 || value ? value : '-'}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default VehicleInfoSection
